module.exports = __webpack_public_path__ + "micro-campaign.svg?6f9af7059a79e6b0794f8d863f98e35b";